import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MapEmbed from "../../components/cards/map";
import { SiteHeader } from "../../components/header/header";
import "../../styles/contact.css";
import { faLegal, faPhoneFlip, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faHome, faIdBadge } from "@fortawesome/free-regular-svg-icons";

export const ContactPage = () => {
    return (
        <div
            className="flx-col"
        >
            <SiteHeader title={"Contact Us"} />
            <div style={{ marginTop: 100 }} />
            <div className="contact-page">
                <div className="page-caption">Kontaktieren Sie uns</div>
                <div className="contact-columns">
                    <div className="flx-col c-al contacts">
                        <button
                            className="contact-buttons sh-box tr-btn"
                            onClick={() => window.location.href = "tel:+4917622006681"}
                        >
                            <div className="phone-icon icon-box">
                                <FontAwesomeIcon className="adrr-icon" icon={faPhoneFlip} />
                            </div>
                            <div className="addr-labels">
                                <div className="top-label">Telefon</div>
                                <div className="bottom-label ph">+4917622006681</div>
                            </div>
                        </button>
                        <button
                            className="contact-buttons sh-box tr-btn"
                            onClick={() => window.location.href = "https://wa.me/+4917622006681"}
                        >
                            <div className="wht-icon icon-box">
                                <FontAwesomeIcon className="adrr-icon" icon={faWhatsapp} />
                            </div>
                            <div className="addr-labels">
                                <div className="top-label">WhatsApp</div>
                                <div className="bottom-label wh">+4917622006681</div>
                            </div>
                        </button>
                        <a href="mailto:actreinigung@gmail.com" className="mail-link">
                            <button
                                className="contact-buttons sh-box tr-btn"
                                onClick={() => window.location.href = `mailto:actreinigung@gmail.com`}
                            >
                                <div className="mail-icon icon-box">
                                    <FontAwesomeIcon className="adrr-icon" icon={faEnvelope} />
                                </div>
                                <div className="addr-labels">
                                    <div className="top-label">Email</div>
                                    <div className="bottom-label em">actreinigung@gmail.com</div>
                                </div>
                            </button>
                        </a>
                        <div className="map-container sh-box">
                            <div className="addr-labels sp-3">
                                <div className="top-label">Address</div>
                                <div className="bottom-label addr-label">Brigitte Reimann Str. 27, Berlin</div>
                            </div>
                            <MapEmbed />
                        </div>
                    </div>
                    <div className="address-column flx-col">
                        <div className="addr-caption">Unsere physische Adresse</div>
                        <div className="phy-addr-list flx-col">
                            <div className="phy-list-item">
                                <FontAwesomeIcon icon={faUserTie} className="phy-icon" />
                                <span className="phy-caption">ACT-Umzugs & Reinigungs UG (haftungsbeschrankt)</span>
                            </div>
                            <div className="phy-list-item">
                                <FontAwesomeIcon icon={faHome} className="phy-icon" />
                                <span className="phy-caption">12329 Berlin</span>
                            </div>
                            <div className="phy-list-item">
                                <FontAwesomeIcon icon={faLegal} className="phy-icon" />
                                <span className="phy-caption">
                                    Registergericht: Amtsgetritch Charlottenburg HRB 257062 B
                                </span>
                            </div>
                            <div className="phy-list-item">
                                <FontAwesomeIcon icon={faIdBadge} className="phy-icon" />
                                <span className="phy-caption">USTID DE363532456</span>
                            </div>

                        </div>
                    </div>
                </div>

                {/* <div className="contact-container">
                    <div className="comp-name">
                        ACT-Umzugs & Reinigungs UG (haftungsbeschrankt)
                    </div>
                    <div className="adrr-det">
                        Brigitte Reimann Str. 27
                    </div>
                    <div className="adrr-det">
                        12329 Berlin
                    </div>
                    <div className="adrr-det">Telefon: +4917622006681</div>
                    <div className="adrr-det">E-mail: actreinigung@gmail.com</div>
                    <div className="adrr-det">Register court: Amtsgetritch Charlottenburg HRB 257062 B</div>
                    <div className="adrr-det">USTID DE363532456</div>
                </div> */}


            </div>

        </div>
    )
}